@@ -0,0 +1,169 @@
<template>
  <app-layout>
    <template #header>
      <AppHead title="Report" />
      <div class="row py-2">
        <div class="col-12 col-md-6 col-lg-8 d-flex align-items-center">
          <h2 class="title">Reports</h2>
        </div>
      </div>
      <flash-messages />
    </template>

    <template v-slot:default>
      <form class="row mt-4" @submit.prevent="report">
        <div class="col-12 col-xl-6">
          <card headerStyle="dark" title="" class="mb-3">
            <div class="row">
              <div class="form-group col-12">
                <jet-label for="start_date" value="Select Start Date" />
                <Calendar class="w-100" v-model="form.start_date" dateFormat="mm/dd/yy" show-icon="true" />
                <jet-input-error :message="form.errors.start_date" class="mt-2" />
              </div>

              <div class="form-group col-12">
                <jet-label for="end_date" value="Select End Date" />
                <Calendar class="w-100" v-model="form.end_date" dateFormat="mm/dd/yy" show-icon="true" />
                <jet-input-error :message="form.errors.end_date" class="mt-2" />
              </div>

              <div class="col-12 bottom-button my-4 float-right text-right">
                <jet-button
                  class="px-5"
                  btnStyle="success"
                  icon="fas fa-download"
                  :disable="form.processing"
                  type="submit"
                >Export</jet-button
                >
              </div>
            </div>
          </card>
        </div>

        <div class="col-12 col-xl-6">
          <card headerStyle="info" title="Reports">
            <DataTable
              ref="historiesList"
              v-if="histories && histories.length > 0"
              :paginator="true"
              :rows="10"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              removableSort
              paginatorPosition="both"
              currentPageReportTemplate="({first} - {last} of {totalRecords})"
              :rowsPerPageOptions="[10, 20, 50, 100]"
              sortField="id"
              :sortOrder="-1"
              class="p-datatable-sm admin-datatable"
              tableClass="border-left border-right border-bottom"
              :value="histories"
              dataKey="id"
            >
              <Column field="id" header="#" headerStyle="width: 3em"></Column>
              <Column
                header="Requested At"
                field="created_at"
                headerStyle="width: 10em"
              >
                <template #body="slotProps">
                  {{ moment(slotProps.data.created_at).format("M/D/YY") }}
                </template>
              </Column>
              <Column field="type" header="Dates">
                <template #body="slotProps">
                  {{ moment(slotProps.data.params.start_date).format('M/D/Y') + '-' + moment(slotProps.data.params.end_date).format('M/D/Y') }}
                </template>
              </Column>
              <Column header="Status">
                <template #body="slotProps">
                  {{ slotProps.data.status }}
                  <i
                    class="fas fa-exclamation text-danger"
                    v-if="slotProps.data.status === 'failed'"
                  ></i>
                  <i
                    class="fas fa-check text-success"
                    v-if="slotProps.data.status === 'done'"
                  ></i>
                </template>
              </Column>
              <Column class="button-container text-nowrap" :exportable="false">
                <template #body="slotProps">
                  <a
                    class="btn-short text-nowrap m-1"
                    btnStyle="dark"
                    title="Download result"
                    v-if="slotProps.data.output_file_link"
                    :href="slotProps.data.output_file_link"
                  >
                    <i class="fas fa-download"></i> Download result
                  </a>
                  <jet-button
                    class="btn-short mx-2"
                    btnStyle="danger"
                    icon="fas fa-trash"
                    @click="deleteReport(slotProps.data)"
                    v-if="
                      slotProps.data.status == 'done' ||
                      slotProps.data.status == 'failed'
                    "
                    >Delete</jet-button
                  >
                </template>
              </Column>
            </DataTable>
            <h6 v-else>No Reports</h6>
          </card>
        </div>
      </form>
    </template>
  </app-layout>
</template>

<script>
import moment from "moment";
import Layout from "@/Shared/Admin/Layout";

import Calendar from "primevue/calendar";
import JetButton from "@/Jetstream/Button";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import JetActionMessage from "@/Jetstream/ActionMessage";
import BreadCrumbs from "@/Shared/BreadCrumbs";
import { historyTypes } from "@/Consts";
import AppLayout from "../../Layouts/AppLayout";

export default {
  components: {
    AppLayout,
    JetActionMessage,
    JetButton,
    JetInput,
    JetInputError,
    JetLabel,
    Layout,
    BreadCrumbs,
    Calendar,
  },
  props: {
    user: Object,
    histories: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        start_date: moment().date(1).month('January').format('M/D/Y'),
        end_date: moment().startOf('month').subtract(1, 'hour').format('M/D/Y'),
      }),
      deleteForm: this.$inertia.form({}),
      historyTypes,
      checkHistoriesInterval: undefined,
    };
  },
  created() {
    this.moment = moment;
  },
  mounted() {
    this.checkHistoriesInterval = setInterval(() => {
      this.getHistories();
    }, 30000);
  },
  unmounted() {
    this.checkHistoriesInterval && clearInterval(this.checkHistoriesInterval)
  },
  methods: {
    report() {
      this.form.start_date = moment(this.form.start_date).startOf('day');
      this.form.end_date = moment(this.form.end_date).endOf('day');
      this.form.post(this.route("process.mtd.report"));
      this.form.start_date = moment().date(1).month('January').format('M/D/Y');
      this.form.end_date = moment().startOf('month').subtract(1, 'hour').format('M/D/Y');
    },
    getHistories() {
      this.$inertia.reload({
        only: ["histories"],
      });
    },
    deleteReport(report) {
      if (!report) {
        return;
      }
      this.$confirm.require({
        message: "Are you sure to delete the report and its files?",
        header: "Delete Report",
        icon: "text-danger pi pi-exclamation-triangle",
        acceptLabel: "Yes",
        rejectLabel: "Cancel",
        accept: () => {
          this.deleteForm.post(
            this.route("process.mtd.deleteAccountActivityReport", [report.id]),
            {
              onSuccess: () => {
                this.getHistories();
              },
            }
          );
        },
      });
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
